// The commands of a session's prompt box. The agent says which it offers, in
// its last ACP `available_commands_update` (sessions/info.ts). Typing a slash
// at the start of the box, and no space yet, asks for one: the list is
// narrowed by what follows the slash, and choosing an entry writes its name
// into the box, ready for its arguments. Moved from today's Code tab
// (code/commands.ts there); ACP names no aliases and no kinds.
import type { AgentCommand } from '../sessions/info'

/** How many entries the list shows at most: more are reached by typing. */
export const COMMANDS_SHOWN = 40

/**
 * What the box asks the list for: the letters after a slash that begins the
 * text, while nothing else was typed. Null when the box holds no such call:
 * any other text, a space after the name (its arguments are his to write),
 * or a second line.
 */
export function commandQuery(draft: string): string | null {
  const found = /^\/([^\s/]*)$/.exec(draft)
  return found ? found[1]!.toLowerCase() : null
}

/**
 * The commands a query names, the best first: those whose name begins with
 * it, then those that hold it anywhere in their name. Each keeps the agent's
 * order within its rank.
 */
export function matchCommands(commands: readonly AgentCommand[], query: string): AgentCommand[] {
  const ranked: AgentCommand[][] = [[], []]
  for (const command of commands) {
    const name = command.name.toLowerCase()
    if (name.startsWith(query)) ranked[0]!.push(command)
    else if (name.includes(query)) ranked[1]!.push(command)
  }
  return ranked.flat().slice(0, COMMANDS_SHOWN)
}

/** The box's text once a command was chosen: its call, and a space for what follows. */
export function commandText(command: AgentCommand): string {
  return `/${command.name} `
}
